import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Modal, Typography } from "@mui/material";
import { modalStyle } from "../../../../assets/dashboardStyles";
import { useMainContext } from "../../../../context/useMainContext";

export default function AudienceData() {
  const {
    currentAudienceData,
    audienceModalOpen,
    setAudienceModalOpen,
  } = useMainContext();
  return (
    <Modal open={audienceModalOpen} onClose={() => setAudienceModalOpen(false)}>
      <Box
        sx={{
          ...modalStyle,
          width: { xs: "90%", md: "600px" },
          backgroundColor: "#fff",
          color: "#111",
          p: 4,
          borderRadius: 4,
          boxShadow: 24,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textAlign: "center", mb: 3, fontSize: 18 }}
        >
          {currentAudienceData?.type === "audience_countries_full"
            ? "All Countries"
            : currentAudienceData?.type === "audience_languages_full"
              ? "All Languages"
              : currentAudienceData?.type === "audience_cities_full"
                ? "Top Cities"
                : currentAudienceData?.type === "audience_interests_full"
                  ? "Audience Interests"
                  : "Audience Data"}{" "}
          - {currentAudienceData?.influencer}
        </Typography>

        {currentAudienceData?.data && (
          <Box sx={{ mb: 3 }}>
            {currentAudienceData.data.map((item, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                  px: 2,
                  borderBottom:
                    idx < currentAudienceData.data.length - 1
                      ? "1px solid #eee"
                      : "none",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                >
                  {currentAudienceData.type === "audience_countries_full"
                    ? item.country
                    : currentAudienceData.type === "audience_languages_full"
                      ? item.language
                      : currentAudienceData.type === "audience_cities_full"
                        ? item.city
                        : currentAudienceData.type === "audience_interests_full"
                          ? item.mention
                          : "Unknown"}
                </span>
                <span
                  style={{
                    fontWeight: 600,
                    color: "#1976d2",
                    fontSize: "14px",
                  }}
                >
                  {Number(item.value || 0).toFixed(1)}%
                </span>
              </Box>
            ))}
          </Box>
        )}

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button
            onClick={() => setAudienceModalOpen(false)}
            sx={{
              color: "#333",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                textDecoration: "underline",
                background: "transparent",
              },
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
